// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__BJ7H1","handle":"Toggle_handle__KUKKN","icon":"Toggle_icon__q45kc"};